import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import workHistoryService from './workHistroyService' 
import { toast } from 'react-toastify';
// The state may only have a single workerView, employerView_byWorker, employerView_byJobsite populated at a time.
const initialState = {
    workerView_monthlyPunchData: [],
    employerView_byWorker: [],
    employerView_byJobsite: [], 
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: ''
}

// Get a worker's punch in/out transactions monthly history
// This will update the workerView_monthlyPunchData field of the state
// Requires a month, workerId is obtained from the token at the backend. 
export const getWorkerViewHistory = createAsyncThunk(
    'workHistory/getWorkerViewHistory', 
    async (month, thunkAPI) => {
        try {
            const token = thunkAPI.getState().workerAuth.workerUser.webToken
            return await workHistoryService.getMonthlyPunchData_Worker(month, token)
        } catch (error) {
            const message = 
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(message)
        }
    }
)

export const getJobsiteAttendance_employerView = createAsyncThunk(
    'jobsiteAttendance',
    async (payload, thunkAPI) => {
        try {
            const { token } = thunkAPI.getState().auth.user; // Extract token from state
            return await workHistoryService.getJobsiteAttendance(payload, token);
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const getWorkerAttendance_employerView = createAsyncThunk(
    'workerAttendance', 
    async (payload, thunkAPI) => {
        try {
            const { token } = thunkAPI.getState().auth.user;
            return await workHistoryService.getAttendanceByWorker(payload, token);
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)


export const workHistorySlice = createSlice({
    name: 'workHistory',
    initialState,
    reducers: {
        
        reset: (state) => initialState,
    },
    extraReducers: (builder) => {
        builder 
            .addCase(getWorkerViewHistory.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getWorkerViewHistory.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.workerView_monthlyPunchData = Array.isArray(action.payload.punchRecords) ? action.payload.punchRecords : []
            })
            .addCase(getWorkerViewHistory.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            }) 



            // --------------------------
            // Get jobsite attendance for employer view
            .addCase(getJobsiteAttendance_employerView.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getJobsiteAttendance_employerView.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.employerView_byJobsite = Array.isArray(action.payload) ? action.payload : []
                if(!action.payload || action.payload.length === 0) {
                    toast.info('No data found for the selected date range.');
                }
            })
            .addCase(getJobsiteAttendance_employerView.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })

            // --------------------------
            // Get worker attendance for employer view
            .addCase(getWorkerAttendance_employerView.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getWorkerAttendance_employerView.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.isError = false
                //ensure the state is always an array
                state.employerView_byWorker = Array.isArray(action.payload) ? action.payload : []
                // Handle 204 No Content scenario
                if (!action.payload || action.payload.length === 0) {
                    toast.info('No data found for the selected date range.');
                }
            })
            .addCase(getWorkerAttendance_employerView.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })


            
    },
})

export const { reset } = workHistorySlice.actions
export default workHistorySlice.reducer